import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Practice from './pages/Practice';
import Dashboard from './pages/Dashboard';
import TeacherDashboard from './pages/TeacherDashboard';
import Lessons from './pages/Lessons';
import Camera from './pages/Camera';
import './App.css';

function ProtectedRoute({ children, teacherOnly = false }: { children: React.ReactNode; teacherOnly?: boolean }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (teacherOnly && !user.isTeacher) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="app">
      <Routes>
        <Route path="/login" element={user ? <Navigate to={user.isTeacher ? "/teacher" : "/dashboard"} replace /> : <Login />} />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/practice" element={
          <ProtectedRoute>
            <Practice />
          </ProtectedRoute>
        } />
        <Route path="/teacher" element={
          <ProtectedRoute teacherOnly>
            <TeacherDashboard />
          </ProtectedRoute>
        } />
        <Route path="/lessons" element={
          <ProtectedRoute teacherOnly>
            <Lessons />
          </ProtectedRoute>
        } />
        <Route path="/camera" element={
          <ProtectedRoute>
            <Camera />
          </ProtectedRoute>
        } />
        <Route path="/" element={<Navigate to={user ? (user.isTeacher ? "/teacher" : "/dashboard") : "/login"} replace />} />
      </Routes>
    </div>
  );
}

export default App;
